module.exports = __webpack_public_path__ + "static/img/ls5.4f0c356.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/ls5.png
// module id = Z+Ek
// module chunks = 12